import React from 'react';
import {useFormContext, Controller} from 'react-hook-form';
import {
    FormControl,
    FormLabel,
    TextField,
    MenuItem,
    FormHelperText,
} from '@material-ui/core';
import get from 'lodash.get';
import {optionsObjectToArray} from './optionsHelper';
import {toSnakeCase} from '../locale/utils';
import {Text} from '.';

const transformIfNotArray = options => {
    if (!Array.isArray(options)) {
        return optionsObjectToArray(options);
    }
    // Convert simple arrays to options objects
    if (typeof options[0] !== 'object') {
        return options.map(opt => ({value: opt, label: opt}));
    }
    return options;
};

const Select = props => {
    const {
        label,
        name,
        options,
        onChange,
        placeholder,
        required,
        inputProps,
        autocomplete,
        hidden,
        manualLabel,
    } = props;
    const {control, errors} = useFormContext();
    const error = get(errors, name);

    const renderedOptions = React.useMemo(() => {
        return transformIfNotArray(options).map(option => (
            <MenuItem key={option.value} value={option.value}>
                {option.label}
            </MenuItem>
        ));
    }, [options]);

    return hidden ? (
        <Text {...props} />
    ) : (
        <FormControl fullWidth error={!!error}>
            {manualLabel ? (
                <FormLabel required={required}>{label}</FormLabel>
            ) : null}
            <Controller
                render={p => (
                    <TextField
                        {...p}
                        {...props}
                        error={!!error}
                        fullWidth
                        select
                        id={toSnakeCase(name)}
                        onBlur={p.onBlur}
                        onChange={(...args) => {
                            onChange && onChange(...args);
                            p.onChange(...args);
                        }}
                        name={p.name}
                        value={p.value || ''}
                        placeholder={placeholder}
                        inputProps={{
                            ...inputProps,
                            autocomplete,
                        }}
                        data-cy={`form-field-${toSnakeCase(name)}`}
                    >
                        {renderedOptions}
                    </TextField>
                )}
                control={control}
                name={name}
            />
            <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
    );
};

export default Select;
